("use strict");
import { fixedDepositsConstants, responseCodes } from "../_constants";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import { ajaxError } from "../_actions";
import {
  fixedDepositReceiptComplete,
  fixedDepositReceiptError,
  fixedDepositsEligibleCasaListComplete,
  fixedDepositsEligibleCasaListError,
  fixedDepositsListComplete,
  fixedDepositsListError,
  fixedDepositsOpenInitiateComplete,
  fixedDepositsOpenInitiateError,
  fixedDepositsOtpConfirmationComplete,
  fixedDepositsOtpConfirmationError,
  fixedDepositsOtpResendComplete,
  fixedDepositsOtpResendError,
  fixedDepositsProductDetailsComplete,
  fixedDepositsProductDetailsError,
  fixedDepositsRateListComplete,
  fixedDepositsRateListError,
} from "../_actions/fixedDeposits.actions";

export const fixedDepositsListEpic = (actions$) =>
  actions$.pipe(
    ofType(fixedDepositsConstants.FIXED_DEPOSITS_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fixedDeposits/getFixedDepositsList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fixedDepositsListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fixedDepositsListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fixedDepositsProductDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(fixedDepositsConstants.FIXED_DEPOSITS_PRODUCT_DETAILS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fixedDeposits/getFixedDepositsProductDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fixedDepositsProductDetailsComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fixedDepositsProductDetailsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fixedDepositsOpenInitiateEpic = (actions$) =>
  actions$.pipe(
    ofType(fixedDepositsConstants.FIXED_DEPOSITS_OPEN_INITIATE_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fixedDeposits/getFixedDepositsOpenInitiate",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fixedDepositsOpenInitiateComplete(ajaxResponse.response),
          ),
          catchError((error) => {
            // Don't show generic error alert, let the UI handle it
            if (
              !error?.response ||
              error?.response?.statusCode === responseCodes.SERVICE_ERROR_CODE
            ) {
              return of(
                fixedDepositsOpenInitiateError({
                  response: {
                    statusCode: responseCodes.SERVICE_ERROR_CODE,
                    message: error?.response?.message || "Service error occurred",
                  },
                }),
              );
            }
            return of(fixedDepositsOpenInitiateError(error));
          }),
        );
    }),
  );

export const fixedDepositsRateListEpic = (actions$) =>
  actions$.pipe(
    ofType(fixedDepositsConstants.FIXED_DEPOSITS_RATE_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fixedDeposits/getFixedDepositsRateList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fixedDepositsRateListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fixedDepositsRateListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fixedDepositsEligibleCasaListEpic = (actions$) =>
  actions$.pipe(
    ofType(fixedDepositsConstants.FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fixedDeposits/getFixedDepositsEligibleCasaList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fixedDepositsEligibleCasaListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fixedDepositsEligibleCasaListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fixedDepositOtpConfirmationEpic = (actions$) =>
  actions$.pipe(
    ofType(fixedDepositsConstants.FIXED_DEPOSITS_OTP_CONFIRMATION_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fixedDeposits/getFixedDepositsOtpConfirmation",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fixedDepositsOtpConfirmationComplete(ajaxResponse.response),
          ),
          catchError((error) => {
            {
              if (
                !error?.response ||
                ![
                  responseCodes.SUCCESS_CODE,
                  responseCodes.FIXED_DEPOSIT_OPENING_TRANSFER_TIMEOUT,
                  responseCodes.FIXED_DEPOSIT_OPENING_FAILED,
                  responseCodes.OTP_FAILED,
                  responseCodes.OTP_BLOCKED,
                  responseCodes.OTP_EXPIRED,
                ].includes(error?.response?.statusCode)
              ) {
                return of(
                  fixedDepositsOtpConfirmationError({
                    response: {
                      statusCode: responseCodes.FIXED_DEPOSIT_OPENING_FAILED,
                    },
                  }),
                );
              }
              if (
                error?.response?.statusCode &&
                error?.response?.statusCode !==
                  responseCodes.FIXED_DEPOSIT_OPENING_FAILED &&
                error?.response?.statusCode !==
                  responseCodes.FIXED_DEPOSIT_OPENING_TRANSFER_TIMEOUT
              ) {
                return of(ajaxError(error));
              } else {
                return of(
                  fixedDepositsOtpConfirmationError(
                    error?.response?.errorResponse || error,
                  ),
                );
              }
            }
          }),
        );
    }),
  );

export const fixedDepositOtpResendEpic = (actions$) =>
  actions$.pipe(
    ofType(fixedDepositsConstants.FIXED_DEPOSITS_OTP_RESEND_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fixedDeposits/getFixedDepositsOtpResend",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fixedDepositsOtpResendComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fixedDepositsOtpResendError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fixedDeposiReceiptEpic = (actions$) =>
  actions$.pipe(
    ofType(fixedDepositsConstants.FIXED_DEPOSITS_RECEIPT_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fixedDeposits/getFixedDepositsReceipt",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fixedDepositReceiptComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fixedDepositReceiptError(error), ajaxError(error)),
          ),
        );
    }),
  );
